import React from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './footer/index';
import HeaderComponent from './HeaderComponent/index';
import 'flowbite';
import Header from './ResponsiveHeader/Header';
import CustomSidebar from './ResponsiveHeader/CustomSidebar';
import { CustomStackedLayout } from './ResponsiveHeader/CustomStackedLayout';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const hideHeader = location.pathname.startsWith('/dashboard');
  return (
    <>
      {!hideHeader && <HeaderComponent />}
      <main>{children}</main>
      {!hideHeader && <Footer />}
      {/* <CustomStackedLayout navbar={<Header />} sidebar={<CustomSidebar isLoggedIn={true} />} isLoggedIn={true}>
        {children}
      </CustomStackedLayout> */}
    </>
  );
};

export default Layout;
